//--------------------------------------------------------------------- 
// Important 
// 
// Copyright in this document remains the property of RAPP Limited 
// and this document may not be reproduced in whole or part without 
// our prior written consent.
// All information of whatever nature contained in this document is
// strictly confidential and may not be used, implemented, adapted or 
// communicated to any third party without the consent of RAPP Limited.
// 
//---------------------------------------------------------------------
// Module . . : testdrive.localization.js   
// System . . : Test Drive
// Author . . : Neil Weaver 
// Date . . . : March 2017
//---------------------------------------------------------------------
// Description
// Calls the tranlate method via ajax to return translation text
// 
//---------------------------------------------------------------------
// Change         Date        Amended by /
// Control        DD/MM/YY    Description
// -------        --------    -------------
//
//---------------------------------------------------------------------*/

    function fnGetTranslationAsync(resId){
        return $.ajax({
            url: "/ajax/GetTranslation",
            data: { resourceId: resId }
        });
    }
    
    function fnUppercaseFirstChar(str) {
        str = str.toLowerCase().replace('/\b[a-z]/g', function (letter) {
            return letter.toUpperCase();
        });
    }